const useStyles = {
  container: {
    gap: 2,
    margin: 1,
  },
  deviceOverview: (isSmallScreen: boolean) => ({
    marginTop: 3,
    gap: 3,
    alignContent: 'flex-start',
    maxWidth: isSmallScreen ? undefined : '440px',
  }),
  photoContainer: (isSmallScreen: boolean) => ({
    width: isSmallScreen ? undefined : '114px',
    maxHeight: '119px',
    alignSelf: 'flex-start',
  }),
  deviceSummary: (isSmallScreen: boolean) => ({
    minWidth: isSmallScreen ? undefined : '260px',
  }),
  locationDetails: (isSmallScreen: boolean) => ({
    marginTop: isSmallScreen ? 1 : 0,
  }),
  details: {
    alignContent: 'flex-start',
    marginY: 0,
    minWidth: '300px',
  },
}

export default useStyles
